import { CurrencySelector } from "@circle-react-shared/Billing/CurrencySelector";
import { useNavigate } from "@tanstack/react-router";

import { usePlans } from "./PlansContext";

export const BillingCurrency = () => {
  const { shouldRenderBillingCurrency, billingCurrency } = usePlans();
  const navigate = useNavigate();

  const handleCurrencyChange = (currency: string) => {
    void navigate({
      to: ".",
      replace: true,
      search: prev =>
        ({
          ...prev,
          billing_currency: currency,
        }) as unknown as typeof prev,
    });
  };

  return shouldRenderBillingCurrency ? (
    <CurrencySelector
      billingCurrency={billingCurrency}
      onCurrencyChange={handleCurrencyChange}
      useCurrencySymbol
    />
  ) : null;
};
